<h3-right-collapsing-panel>
  <div projection-location="menu-bar" class="shapelist-menu-bar">
    <div>
      <button
        class="btn btn-default btn-xs"
        matTooltip="Shape Filters"
        (click)="showFilterEditor()"
        [disabled]="filterButtonDisabled$ | async"
      >
        <fa-icon [icon]="faFilter"></fa-icon>
      </button>
      <h3-delete-shapes-button
        *ngIf="(readOnly$ | async) === false"
      ></h3-delete-shapes-button>
      <h3-select-all-button></h3-select-all-button>
      <h3-group-shapes-button
        *ngIf="isGroupShapesButtonDisplayed$ | async"
        [groupTypes]="groupTypes"
      ></h3-group-shapes-button>
      <h3-key-location-actions
        *ngIf="(selectedShapeCount$ | async) && (maxFrameNumber$ | async)"
      ></h3-key-location-actions>
    </div>
    <div class="mat-button-containers">
      <ng-container *ngIf="isAddFeedbackButtonDisplayed">
        <button
          (click)="openFeedbackDialog()"
          mat-icon-button
          [disabled]="isAddFeedbackButtonDisabled$ | async"
        >
          <mat-icon svgIcon="addFeedback">add-feedback </mat-icon>
        </button>
      </ng-container>
      <a (click)="expandAll()" *ngIf="(expandedAll$ | async) === false">
        <mat-icon class="material-symbols-outlined" matTooltip="Expand all"
          >unfold_more</mat-icon
        >
      </a>
    </div>
    <a (click)="collapseAll()" *ngIf="expandedAll$ | async">
      <mat-icon class="material-symbols-outlined" matTooltip="Collapse all"
        >unfold_less</mat-icon
      >
    </a>
  </div>
  <div>
    <div class="filter-label" *ngIf="isShapeFilterActive$ | async">
      Filters active
    </div>
    <div class="layout-grid">
      <cdk-virtual-scroll-viewport
        *ngIf="useVirtualScrolling$ | async"
        itemSize="50"
        [appendOnly]="true"
        class="content"
        h3TrackScrollEvents="shape_list"
        cdkDropList
        [cdkDropListAutoScrollDisabled]="true"
        (cdkDropListDropped)="reorder($event)"
        h3ScrollEnabler
      >
        <div
          *cdkVirtualFor="let item of listItems$ | async"
          class="list-group-item"
          cdkDrag
          cdkDragLockAxis="y"
          [cdkDragData]="item"
          [cdkDragDisabled]="readOnly$ | async"
          (cdkDragStarted)="dragStarted(item)"
        >
          <h3-shape-list-shape
            *ngIf="item.type === 'shape'"
            [shapeIndex]="item.index"
            [hoverButtonTemplate]="hoverButtonTemplate"
            [staticButtonTemplate]="staticButtonTemplate"
            (newlySelected)="skipNextSelectionEvent = true"
            (contextmenu)="openContextMenu($event, item)"
          >
          </h3-shape-list-shape>
          <h3-shape-group
            *ngIf="item.type === 'group'"
            [groupIndex]="item.index"
            [hoverButtonTemplate]="hoverButtonTemplate"
            [staticButtonTemplate]="staticButtonTemplate"
            (newlySelected)="skipNextSelectionEvent = true"
          >
          </h3-shape-group>
        </div>
      </cdk-virtual-scroll-viewport>
      <div
        *ngIf="useRegularScrolling$ | async"
        class="content"
        h3TrackScrollEvents="shape_list"
        #shapeList
        cdkDropList
        (cdkDropListDropped)="reorder($event)"
        h3ScrollEnabler
      >
        <div
          *ngFor="let item of listItems$ | async"
          class="list-group-item"
          cdkDrag
          cdkDragLockAxis="y"
          [cdkDragData]="item"
          [cdkDragDisabled]="readOnly$ | async"
          (cdkDragStarted)="dragStarted(item)"
        >
          <h3-shape-list-shape
            *ngIf="item.type === 'shape'"
            [shapeIndex]="item.index"
            [hoverButtonTemplate]="hoverButtonTemplate"
            [staticButtonTemplate]="staticButtonTemplate"
            (contextmenu)="openContextMenu($event, item)"
          >
          </h3-shape-list-shape>
          <h3-shape-group
            *ngIf="item.type === 'group'"
            [groupIndex]="item.index"
            [hoverButtonTemplate]="hoverButtonTemplate"
            [staticButtonTemplate]="staticButtonTemplate"
          >
          </h3-shape-group>
        </div>
      </div>
      <div class="panel-footer text-center">
        {{ shapeCountText$ | async }}
      </div>
    </div>
  </div>
</h3-right-collapsing-panel>
